import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { PDFSafeTableHeaderCaption } from '../../../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useIsPdf } from '../../../../FinancialPlanOPL/hooks/useIsPdf';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { hasAccessToEditProfileSelector } from '../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  title: string;
  isEmpty: boolean;
  columnHeaders: ColumnHeader[];
  children: React.ReactNode;
  onAddInsurance(): void;
  workflowProps?: WorkflowComponentProps;
}

export const InsuranceTable = ({
  title,
  isEmpty,
  columnHeaders,
  children,
  onAddInsurance,
  workflowProps,
}: Props) => {
  const isPrint = useIsPdf();

  const canEdit = useSelector(hasAccessToEditProfileSelector);

  if (isEmpty) {
    return (
      <HtmlTable variant={workflowProps && 'bordered'}>
        <Box p="16">
          <Text variant="cardTitle" color="neutral.700" pb="16">
            {title}
          </Text>

          {isPrint || !canEdit ? (
            <Text fontWeight={500} color="neutral.500">
              No Insurance available.
            </Text>
          ) : (
            <Button leftIcon="fas fa-plus" variant="link" onClick={onAddInsurance}>
              Add Insurance
            </Button>
          )}
        </Box>
      </HtmlTable>
    );
  }

  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <table>
        <thead>
          <PDFSafeTableHeaderCaption
            colSpan={isPrint ? columnHeaders.length : columnHeaders.length + 1}
          >
            {title}
          </PDFSafeTableHeaderCaption>
          <tr>
            {columnHeaders.map(({ text, align }) => (
              <th key={text} style={{ whiteSpace: 'unset' }}>
                <Text variant="smallCaps" textAlign={align || 'left'}>
                  {text}
                </Text>
              </th>
            ))}

            {!isPrint && <th aria-label={`Actions for ${title}`}>&nbsp;</th>}
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </HtmlTable>
  );
};
